import React from 'react';
import ExecutiveTemplate from './ExecutiveTemplate';
import FinanceTemplate from './FinanceTemplate';
import SalesTemplate from './SalesTemplate';
import InvestorTemplate from './InvestorTemplate';
import MemberTemplate from './MemberTemplate';

const TEMPLATE_MAP = {
  executive: ExecutiveTemplate,
  finance: FinanceTemplate,
  sales: SalesTemplate,
  investor: InvestorTemplate,
  member: MemberTemplate,
};

const CompanyDashboardView = ({ data }) => {
  const Template = TEMPLATE_MAP[data.template] || MemberTemplate;
  return <Template data={data} />;
};

export default CompanyDashboardView;
